import { MetadataBlockContext } from '@/context/MetadataBlockContext';
import { useContext } from 'react';

export const useMetadataBlock = () => useContext(MetadataBlockContext);
